import { AE_BROKERS_URL } from './aeBrokerQualityApi.constants';

/**
 * AE broker-roster client — Accounts gateway (DEV-3781). GET
 * /api/account-executives/me/brokers returns the brokers the signed-in AE owns:
 *   { brokers: [{ subCompanyId, subCompanyName, companyId }], asOf }
 *
 * Self-scoped from the JWT — no path param. The whole AE broker-quality page is
 * dark until a backend feature toggle is on; when off this endpoint 404s, which
 * the slice treats as "not available" (page hidden / disabled). A 403 (auth gap)
 * degrades the same way, so the caller passes skipResponseInterceptor
 * forbiddenError to avoid the global page-reload loop.
 */
export class AeBrokersApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getMyBrokers({ config = {} } = {}) {
    return this.#http.get(AE_BROKERS_URL, config);
  }
}
